import { render, staticRenderFns } from "./AdvertisementAgreeJoin.vue?vue&type=template&id=2963a742&scoped=true&"
import script from "./AdvertisementAgreeJoin.vue?vue&type=script&lang=ts&"
export * from "./AdvertisementAgreeJoin.vue?vue&type=script&lang=ts&"
import style0 from "./AdvertisementAgreeJoin.vue?vue&type=style&index=0&id=2963a742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2963a742",
  null
  
)

export default component.exports